import { objectSpread2 as _objectSpread2 } from "../../_virtual/_rollupPluginBabelHelpers.js";
import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { FormLabelGroup, Select } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { mapAssignmentKeyToParties } from "../../helpers/fieldAssignment.js";
import { uniqBy } from 'lodash';
import useStores from "../../hooks/useStores.js";

var FieldAssignmentTypeDropdown = function FieldAssignmentTypeDropdown(_ref) {
  var _assignmentStore$find;

  var label = _ref.label;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      assignmentStore = _useStores.assignmentStore;

  var selectedField = pdfStore.selectedField;
  var data = selectedField.data;
  var currentType = (_assignmentStore$find = assignmentStore.findOptionByKey(data.assignedTo)) === null || _assignmentStore$find === void 0 ? void 0 : _assignmentStore$find.assignmentType;

  if (pdfStore.documentPartyMappings.length && !data.parties.length) {
    currentType = undefined;
  }

  var handleChange = function handleChange(_ref2) {
    var _assignmentStore$opti;

    var value = _ref2.value;
    var assignedTo = (_assignmentStore$opti = assignmentStore.options.filter(function (opt) {
      return opt.assignmentType === value;
    }).find(Boolean)) === null || _assignmentStore$opti === void 0 ? void 0 : _assignmentStore$opti.assignmentKey;
    if (!assignedTo) return;
    selectedField.setData(_objectSpread2(_objectSpread2({}, data), {}, {
      assignedTo: assignedTo
    }));
    assignmentStore.updatePartyAssignments(selectedField, assignedTo);
  };

  var options = assignmentStore.options.map(function (_ref3) {
    var assignmentKey = _ref3.assignmentKey,
        assignmentType = _ref3.assignmentType;

    if (pdfStore.documentPartyMappings.length) {
      var parties = mapAssignmentKeyToParties(assignmentKey, pdfStore.documentPartyMappings);
      if (!parties.length) return null;
    }

    return {
      label: assignmentType,
      value: assignmentType
    };
  }).filter(Boolean);
  options = uniqBy(options, 'value');
  return jsx(FormLabelGroup, {
    label: label,
    stacked: true
  }, jsx(Select, {
    value: currentType,
    onChange: handleChange,
    clearable: false,
    className: "w-100",
    options: options
  }));
};

FieldAssignmentTypeDropdown.displayName = "FieldAssignmentTypeDropdown";
FieldAssignmentTypeDropdown.propTypes = {
  label: _pt.string.isRequired,
  children: _pt.node
};
var FieldAssignmentTypeDropdown$1 = observer(FieldAssignmentTypeDropdown);
export default FieldAssignmentTypeDropdown$1;